import { COUNTRY_CODE } from '@/utils/constants';
import { SOLSHARE_VERSION } from '@/shared/constants/solshare';
import { getSolshareVersion } from '@/shared/utils/solshare-serial';

export const INVERTER_BRAND_OTHER = 'Other';

export const getInverterBrandOptions = (country: COUNTRY_CODE) => {
  switch (country) {
    case COUNTRY_CODE['United Kingdom']:
    case COUNTRY_CODE.Germany:
      return [
        { label: 'Fox ESS', value: 'Fox ESS', battery_integration_supported: true },
        { label: 'Growatt', value: 'Growatt', battery_integration_supported: false },
        { label: 'Sigenergy', value: 'Sigenergy', battery_integration_supported: true },
        { label: 'SolarEdge', value: 'SolarEdge', battery_integration_supported: false },
        { label: 'SolaX', value: 'SolaX', battery_integration_supported: false },
        { label: 'Solis', value: 'Solis', battery_integration_supported: false },
        { label: 'Sungrow', value: 'Sungrow', battery_integration_supported: true },
        { label: 'Other', value: INVERTER_BRAND_OTHER, battery_integration_supported: false },
      ];

    default:
      // Australia, New Zealand, USA, and other countries
      return [
        { label: 'Enphase', value: 'Enphase', battery_integration_supported: false },
        { label: 'Fronius', value: 'Fronius', battery_integration_supported: false },
        { label: 'GoodWe', value: 'GoodWe', battery_integration_supported: false },
        { label: 'Sigenergy', value: 'Sigenergy', battery_integration_supported: true },
        { label: 'SMA', value: 'SMA', battery_integration_supported: false },
        { label: 'SolaX', value: 'SolaX', battery_integration_supported: false },
        { label: 'SolarEdge', value: 'SolarEdge', battery_integration_supported: false },
        { label: 'Sungrow', value: 'Sungrow', battery_integration_supported: true },
        { label: 'Other', value: INVERTER_BRAND_OTHER, battery_integration_supported: false },
      ];
  }
};

export const isBatteryIntegrationSupported = (brand: string | undefined, country: COUNTRY_CODE) =>
  getInverterBrandOptions(country).some(
    (option) => option.value === brand && option.battery_integration_supported,
  );

export const CT_RATING_OPTIONS = [
  { label: '120A (default)', value: 120, default: true },
  { label: '200A', value: 200, default: false },
];

export const findDefaultCTRating = () => {
  const found = CT_RATING_OPTIONS.find((option) => option.default);
  if (found) return found.value;
  if (CT_RATING_OPTIONS.length > 0) return CT_RATING_OPTIONS[0].value;
  return undefined;
};

/**
 * Whether the installer has to pick the CT rating ("Which CTs were used for this SolShare?").
 * MK2 always ships with the default CT rating, so the step is skipped for it.
 */
export const isCTSpecStepRequired = (serialNumber: string) =>
  getSolshareVersion(serialNumber) !== SOLSHARE_VERSION.Mk2;

/**
 * These are the countries that works with kWp
 * when defining the terminal allocations values in the UI.
 *
 * However, take note that the allocations values are still
 * stored in percentage format in the database.
 */
export const KWP_ALLOC_COUNTRIES = [COUNTRY_CODE['United Kingdom']];
